import type { SearchPatternsParams } from '@/entities/pattern';

export const countActiveFilters = (filters: SearchPatternsParams): number => {
    if (!filters) return 0;

    let count = 0;

    // Compte les filtres de type array non vides
    if (filters.Ticker?.length) count += 1;

    if (filters.Timeframe?.length) count += 1;

    // eslint-disable-next-line no-underscore-dangle
    if (filters.pattern_len_?.length) count += 1;

    if (filters.price_threshold_post_mean?.length) count += 1;

    // Compte les filtres de plage min/max
    if (filters.pattern_index_count_min || filters.pattern_index_count_max)
        count += 1;

    if (
        filters.price_drawdown_post_mean_min ||
        filters.price_drawdown_post_mean_max
    )
        count += 1;

    if (filters.price_reg_post_mean_min || filters.price_reg_post_mean_max)
        count += 1;

    // Compte le filtre de direction
    if (filters.direction_type !== undefined) count += 1;

    return count;
};
